// extracted by mini-css-extract-plugin
export default {"container":"Education_container__3gWFV","wrapper":"Education_wrapper__82dT9","heading":"Education_heading__qEBkM","listItems":"Education_listItems__B3P11"};